import { requestGet } from '@/utils/request';

const api = {
    LIST: '/op/action_log_list',
}

export async function actionLogList(queryParams) {
    return requestGet(api.LIST, queryParams);
}